import React from "react";
import { UserAuth } from "../context/AuthContext";
import { Navigate } from "react-router-dom";

function PrivateRoute({ children, protectedRoute }) {
  const { session } = UserAuth();
  if (!protectedRoute) {
    return <>{children}</>;
  }
  if (session === undefined) {
    return <></>;
  }

  // Only admit a live, unexpired session. An expired session would still render
  // the app but run every Supabase request on the anon key — fail closed to
  // /login instead. AuthContext refreshes valid sessions before they land here.
  const isExpired =
    !session?.expires_at || session.expires_at * 1000 <= Date.now();

  return session && !isExpired ? <>{children}</> : <Navigate to="/login" />;
}

export default PrivateRoute;
